import React from 'react';
import { Icon } from 'antd';

const optionsDefault = {
  okText: 'Готово',
  icon: <Icon type="check-circle" theme="filled" />,
  closable: false,
  maskClosable: true,
  centered: true,
  className: 'employee-success-form',
  onOk() {},
  onCancel() {},
};
export const successCreateVehicle = (brand, registerSign, registerRegion) => ({
  ...optionsDefault,
  title: 'ТС успешно добавлено!!',
  content: `ТС «${brand}, ${registerSign}${
    registerRegion ? ' ' + registerRegion : ''
  }» успешно добавлено!`,
});
export const successUpdateVehicle = (brand, registerSign, registerRegion) => ({
  ...optionsDefault,
  title: 'Изменения успешно сохранены!',
  content: `Изменения успешно внесены в данные ТС «${brand}, ${registerSign}${
    registerRegion ? ' ' + registerRegion : ''
  }».`,
});

export const successUpdateVehicleStatus = (regNum, status) => {
  switch (status) {
    case 'archive':
      return {
        ...optionsDefault,
        title: `ТС успешно архивировано!`,
        content: `ТС «${regNum}» успешно архивировано. Назначение на заказы для этого ТС недоступно.`,
      };
    case 'actual':
      return {
        ...optionsDefault,
        title: `ТС успешно восстановлено!`,
        content: `ТС «${regNum}» успешно восстановлено. Назначение на заказы для этого ТС снова доступно.`,
      };
    default:
      return {
        ...optionsDefault,
        title: `Статус успешно изменен!`,
        content: `Статус ТС успешно изменен!`,
      };
  }
};
